/**
 * The three ways a calculator hands its output away. Each goes through the tool's existing gate first
 * (`gate` from useLogToolUsage: it takes the visit's ONE trial use and opens the paywall when none is left),
 * and delivers only if the gate allowed it. Nothing is built or delivered for a blocked person.
 * The limits and the gate itself are unchanged; this only calls them.
 */
export type ExportKind = "copy" | "csv" | "print";
export interface ExportDeps {
  gate: () => Promise<boolean>;
  copyText: (text: string) => Promise<void>;
  saveCsv: (filename: string, csv: string) => void;
  print: () => void;
}

/** Resolves true when the output was delivered. */
export async function runExport(kind: ExportKind, deps: ExportDeps, payload: { text?: string; csv?: string; filename?: string }): Promise<boolean> {
  if (!(await deps.gate())) return false;
  if (kind === "copy") {
    try { await deps.copyText(payload.text ?? ""); return true; } catch { return false; }
  }
  if (kind === "csv") { deps.saveCsv(payload.filename ?? "table.csv", payload.csv ?? ""); return true; }
  deps.print();
  return true;
}
